export const enClientPortalAssetValuationList = {
    emptyStateTitle: 'No orders or valuations are available for this asset yet.',
    item: {
        valuationTitle: 'Valuation report {{date}}',
        valueCheckTitle: 'Value check {{date}}',
        downloadValueCheck: 'Download value check',
        generateValXml: 'Generate ValXML',
        downloadValuation: 'Download report',
        noPdfTooltip: 'No PDF is available for this valuation report.',
    },
}
